<template>
    <div class="container is-fluid">
        <div class="columns">
            <div class="column">
                <h1 class="title has-text-centered">Price Plans</h1>
            </div>
        </div>
        <div class="columns">
            <plans-control></plans-control>
        </div>
        <div class="columns">
            <div class="column">
                <plans-table></plans-table>
            </div>
        </div>
    </div>
</template>

<script>
    import PlansTable from './PlansTable.vue'
    import PlansControl from './PlansControl.vue'
    export default {
        components: {
            PlansTable,
            PlansControl
        }
    }
</script>

<style scoped>
    .title {
        margin-top: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/PlansList.vue